/**
 * @flow
 * @relayHash 71de75b7b9272b71dfadf5c9bdcf028c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FoldersContainer_viewer$ref = any;
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosSortByTypes = "ALPHABETICAL" | "CREATED" | "CUSTOM" | "MODIFIED" | "%future added value";
export type FoldersContainerRefetchQueryVariables = {|
  first: number,
  after?: ?string,
  hasUserId: boolean,
  portfolioTypes?: ?$ReadOnlyArray<?PortfolioTypes>,
  foldersSort?: ?PortfoliosSortByTypes,
  loadPortfolioData: boolean,
  selectedItemIds: $ReadOnlyArray<?string>,
  userId: string,
  userIds: $ReadOnlyArray<?string>,
|};
export type FoldersContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FoldersContainer_viewer$ref
  |}
|};
export type FoldersContainerRefetchQuery = {|
  variables: FoldersContainerRefetchQueryVariables,
  response: FoldersContainerRefetchQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "portfolioTypes",
    "type": "[PortfolioTypes]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "foldersSort",
    "type": "PortfoliosSortByTypes",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "loadPortfolioData",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "selectedItemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2,
  "type": "Int!"
},
v2 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "displayName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "portfolioTypes",
    "variableName": "portfolioTypes",
    "type": "[PortfolioTypes]"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "foldersSort",
    "type": "PortfoliosSortByTypes"
  },
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalResults",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endCursor",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ],
  "type": "[PortfolioTypes]"
},
v10 = [
  (v4/*: any*/),
  (v3/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FoldersContainerRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FoldersContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FoldersContainerRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "trendingCategories",
            "name": "trending",
            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
            "args": [
              {
                "kind": "Literal",
                "name": "categoryLevels",
                "value": 3,
                "type": "Int"
              },
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "trendType",
                "value": "CATEGORY",
                "type": "TrendingTypes!"
              }
            ],
            "concreteType": "TrendingModules",
            "plural": true,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "trendingAttributes",
            "name": "trending",
            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "trendType",
                "value": "ATTRIBUTE",
                "type": "TrendingTypes!"
              }
            ],
            "concreteType": "TrendingModules",
            "plural": true,
            "selections": (v2/*: any*/)
          },
          (v3/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolios",
                "storageKey": null,
                "args": (v6/*: any*/),
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 4,
                                "type": "Int"
                              },
                              {
                                "kind": "Literal",
                                "name": "sortBy",
                                "value": "CUSTOM",
                                "type": "PortfolioItemsSortByTypes"
                              }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "numberOfPages",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pageInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "startCursor",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemV2",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "photos",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemPhoto",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "versions",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemPhotoVersion",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "webPath",
                                                    "args": null,
                                                    "storageKey": null
                                                  }
                                                ]
                                              },
                                              (v3/*: any*/)
                                            ]
                                          },
                                          (v3/*: any*/)
                                        ]
                                      },
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "portfolios",
                "args": (v6/*: any*/),
                "handle": "connection",
                "key": "FoldersRefetchWrapper_portfolios",
                "filters": [
                  "portfolioTypes",
                  "sortBy",
                  "userIds"
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "loadPortfolioData",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "heartItemMatches",
                "name": "portfolioItemMatches",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "itemIds",
                    "variableName": "selectedItemIds",
                    "type": "[String]"
                  },
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "portfolioId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "portfolioItemId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "userPortfolios",
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FoldersContainerRefetchQuery",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/FoldersContainerRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '40b5e979f49b200c7940b975b9c838e5';
module.exports = node;
